import { createRouter, createWebHistory } from 'vue-router';
// import store from '../store/index'; // Importe seu Vuex Store
// import Authentication from '@/services/authentication';
// import LocalStorage from 'quasar/src/plugins/storage/LocalStorage.js';import Notify from 'quasar/src/plugins/notify/Notify.js';

import AuthCognito        from '@/components/Login/AuthCognito.vue'
import LoginGetToken      from '@/components/Login/LoginGetToken.vue'
import ListarOcorrencias        from '@/views/Itau/ListarOcorrencias.vue'
import AcessoNegado        from '@/components/Login/AcessoNegado.vue'

const routes = [
  {
    path: '/',
    name: 'AuthCognito',
    component: AuthCognito,
    meta: { conditionalRouteLogin: false }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginGetToken,
    meta: { conditionalRouteLogin: false }
  },
  {
    path: '/ListarOcorrencias',
    name: 'ListarOcorrencias',
    component: ListarOcorrencias,
    meta: {
      title: 'Listar Ocorrencias Itaú',
      conditionalRouteLogin: true}
  },
  {
    path: '/AcessoNegado',
    name: 'AcessoNegado',
    component: AcessoNegado
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (to.matched.some(record => record.meta.conditionalRouteLogin)) {
    if (localStorage.getItem("isAuthenticated") == null || !localStorage.getItem("isAuthenticated")) {
      next({
        path: '/',
      });
    } else {
      if(localStorage.getItem("grupo") == process.env.VUE_APP_GRUPO_AD){
        next();
      }else{
        next({
          path: '/AcessoNegado',
        });
      }
    }
  } else {
    next();
  }
});


export default router
